// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eVjmc","inner":"Footer_inner__KgF2d","label":"Footer_label__hBt5x"};